import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../MainContext";
import AddCustomer from "./AddCustomer";
import CustomersList from "./CustomersList";
import { Box } from "@mui/material";
import CollapsableBox from "../../CollapsibleBox/CollapsableBox";
import EditCustomer from "./EditCustomer";

const Customers = () => {
    const { darkMode, customers, customerType, updateCustomers, openState, boxOpener, texts } = useContext(MainContext);
    const [edit, setEdit] = useState();

    useEffect(() => {
        updateCustomers()
    }, [customers])

    return (
        <div
            class="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: darkMode ? "black" : "white",
                minHeight: "calc(100vh - 75px)",
            }}
        >
            <div class="layout-container flex h-full grow flex-col">
                <Box>
                    {!edit ? (
                        <CollapsableBox title={texts.customer.addCustomer} isOpen={openState.addCustomer} setIsOpen={() => boxOpener("addCustomer")}>
                            <AddCustomer customers={customers} customerType={customerType} updateCustomers={updateCustomers} darkMode={darkMode} texts={texts} />
                        </CollapsableBox>
                    ) : (
                        <EditCustomer darkMode={darkMode} customers={customers} customerType={customerType} updateCustomers={updateCustomers} edit={edit} setEdit={setEdit} texts={texts} />
                    )}
                </Box>
                <CustomersList darkMode={darkMode} customers={customers} setEdit={setEdit} texts={texts} updateCustomers={updateCustomers} />
            </div>
        </div>
    );
};

export default Customers;
